import curd from '../curd'

const BASE_PATH = '/device/factor'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/DeviceFactor.js